/* loop + twist Fabric Colourway Switcher (OTHER, Sep 2026). Full commented source: project docs fabric-visualiser/colourway-switcher.js */
(function () {
  'use strict';
  var CONFIG = {
    swatchLabel: '.tpo_image-swatches-wrapper label',
    swatchInput: 'input.tpo_image-swatches-input',
    mainImageSelector:
      'product-gallery:not([style*="display: none"]) .product-gallery__media img, ' +
      '.product-gallery__media img, .product__media img, ' +
      '.product-single__photo img, [data-product-image] img',
    widths: [400, 600, 800, 1000, 1200, 1400, 1600, 1800, 2000],
    initDelay: 600,
    preload: true,
    preloadWidth: 800,
    debug: false
  };
  var MAP = window.LT_COLOURWAYS || null;
  var BASE_IMAGE = window.LT_BASE_IMAGE || null;
  var NATIVE = window.LT_STANDARD_UPHOLSTERY || '';
  if (!MAP || typeof MAP !== 'object' || !Object.keys(MAP).length) return;
  if (/[?&]lt_debug=1/.test(location.search)) CONFIG.debug = true;

  function log() {
    if (!CONFIG.debug) return;
    var a = Array.prototype.slice.call(arguments); a.unshift('[lt-colourway]');
    console.log.apply(console, a);
  }
  /* Easify uses an EN DASH between name and code (Velvet uses a hyphen) and Boucle carries an accent. Do not simplify. */
  function normalise(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/gi, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  var LOOKUP = {};
  Object.keys(MAP).forEach(function (k) { LOOKUP[normalise(k)] = MAP[k]; });
  var NATIVE_KEY = normalise(NATIVE);

  /* input.value = colour, input.name = "<uuid>,<Fabric>" : fabric is the LAST comma segment */
  function parseSwatch(label) {
    var input = label.querySelector(CONFIG.swatchInput);
    if (!input) return null;
    var colourName = (input.value || '').trim();
    if (!colourName) return null;
    var parts = (input.name || '').split(',');
    return { colourName: colourName, fabricType: parts.length > 1 ? parts[parts.length - 1].trim() : '' };
  }
  function findImage(sw) {
    var keys = [normalise(sw.fabricType + ' ' + sw.colourName), normalise(sw.colourName + ' ' + sw.fabricType), normalise(sw.colourName)];
    for (var i = 0; i < keys.length; i++) {
      if (LOOKUP[keys[i]]) { log('matched', keys[i]); return LOOKUP[keys[i]]; }
    }
    log('no match', keys);
    return null;
  }
  function isNative(sw) {
    if (!NATIVE_KEY) return false;
    return NATIVE_KEY === normalise(sw.fabricType + ' ' + sw.colourName) || NATIVE_KEY === normalise(sw.colourName + ' ' + sw.fabricType);
  }
  function getHero() { return document.querySelector(CONFIG.mainImageSelector); }
  /* Update src, srcset, data-src and <picture> sources or breakpoints keep a cached image */
  function swapHero(url) {
    var img = getHero();
    if (!img || !url) return false;
    var base = url.split('?')[0];
    var srcset = CONFIG.widths.map(function (w) { return base + '?width=' + w + ' ' + w + 'w'; }).join(', ');
    img.src = base + '?width=2000';
    img.srcset = srcset;
    if (img.dataset && img.dataset.src) img.dataset.src = base + '?width=2000';
    img.removeAttribute('loading');
    var pic = img.closest && img.closest('picture');
    if (pic) pic.querySelectorAll('source').forEach(function (s) { s.srcset = srcset; });
    log('swapped', base);
    return true;
  }
  function restore() { if (BASE_IMAGE) swapHero(BASE_IMAGE); }
  function handle(label) {
    var sw = parseSwatch(label);
    if (!sw) return;
    log('clicked', sw);
    if (/wood/i.test(sw.fabricType)) { log('wood, ignoring'); return; }
    if (isNative(sw)) { log('native colourway, restoring photograph'); restore(); return; }
    var url = findImage(sw);
    /* No render for this colour (e.g. another fabric family): show the photograph, never a stale render */
    if (url) swapHero(url); else restore();
  }
  function preload() {
    if (!CONFIG.preload) return;
    var urls = Object.keys(LOOKUP).map(function (k) { return LOOKUP[k]; });
    var i = 0;
    function next(d) {
      while (i < urls.length && (!d || d.timeRemaining() > 4)) {
        var im = new Image(); im.src = urls[i].split('?')[0] + '?width=' + CONFIG.preloadWidth; i++;
      }
      if (i < urls.length) schedule();
    }
    function schedule() {
      if (window.requestIdleCallback) window.requestIdleCallback(next, { timeout: 4000 });
      else setTimeout(function () { next(null); }, 1200);
    }
    schedule();
  }
  /* Touch devices: Easify's hover tooltip makes iOS treat the first tap as a hover, so the swatch needed two taps.
     The snippet CSS hides that tooltip on (hover: none) devices so one tap selects; this briefly shows the
     colour name on the tapped swatch instead. */
  var lastPointer = '';
  var tipTimer = null;
  function showTapTip(label) {
    var wrap = label.closest('.tpo_image-swatches-wrapper');
    if (!wrap) return;
    document.querySelectorAll('.lt-tap-tip').forEach(function (w) { w.classList.remove('lt-tap-tip'); });
    wrap.classList.add('lt-tap-tip');
    clearTimeout(tipTimer);
    tipTimer = setTimeout(function () { wrap.classList.remove('lt-tap-tip'); }, 1600);
  }
  function init() {
    log('init', Object.keys(LOOKUP).length, 'colourways, native:', NATIVE || '(none)');
    if (!getHero()) log('WARNING: no hero image matched');
    /* Delegated listeners survive Easify re-rendering its option block */
    document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || ''; }, true);
    document.addEventListener('click', function (e) {
      var label = e.target.closest && e.target.closest(CONFIG.swatchLabel);
      if (!label) return;
      if (lastPointer === 'touch') showTapTip(label);
      setTimeout(function () { handle(label); }, 0);
    }, true);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches(CONFIG.swatchInput)) { var l = t.closest(CONFIG.swatchLabel); if (l) handle(l); return; }
      /* Fabric family tabs (Suede / Velvet ...) are Shopify variant options on this store: reset to the photograph */
      if (t.matches('input[name*="Upholstery"], select[name*="Upholstery"], input[name*="main-option"], select[name*="main-option"]')) { log('fabric family changed, resetting'); restore(); }
    }, true);
    preload();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, CONFIG.initDelay); });
  } else {
    setTimeout(init, CONFIG.initDelay);
  }
})();
